/** Título repetido nas telas ("Acesso não autorizado", 43 ocorrências no código). */
export const FORBIDDEN_TITLE = "Acesso não autorizado";
/** Texto novo (as telas mostram a mensagem do serviço): usado quando a tela não informa a descrição. */
export const FORBIDDEN_DESCRIPTION = "Você não tem permissão para acessar este conteúdo.";
export const GENERIC_ERROR = "Não foi possível carregar os dados.";
export const LOADING_LABEL = "Carregando…";
export const RETRY_LABEL = "Tentar novamente";
